import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { RichText } from 'prismic'

import s from './Awards.module.scss'
const cn = classNames.bind(s)

const ListItem = ({ data }) => {
  const award = data.award

  return (
    <div className={cn('award')}>
      <div className="headline3">{RichText.render(award)}</div>
    </div>
  )
}

ListItem.propTypes = {
  data: PropTypes.object.isRequired,
}

export default ListItem
